// extracted by mini-css-extract-plugin
module.exports = {"warningCompleteVirtualAccount":"Withdrawal_warningCompleteVirtualAccount__3ciBu","proceedNumber":"Withdrawal_proceedNumber__3QwF_"};